import React from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { formatBoxCbmDisplay } from './tearSheetUtils';

export default function TearSheetPackTableSection({
  title,
  packKey,
  rows,
  barcodeTypes,
  readOnly = false,
  onChange,
  onAdd,
  onRemove,
  className = '',
}) {
  return (
    <section className={`tear-sheet-section mt-2 ${className}`.trim()}>
      <h5 className="tear-sheet-section-title">{title}</h5>
      <div className="table-responsive tear-sheet-pack-table-wrap">
        <table className="table table-sm table-bordered align-middle mb-2 tear-sheet-pack-table">
          <thead className="table-light">
            <tr>
              <th>Qty pack</th>
              <th>Length</th>
              <th>Breadth</th>
              <th>Height</th>
              <th>Box CBM</th>
              <th>Gross wt</th>
              <th>Barcode type</th>
              {!readOnly && <th className="text-center w-tear-del"> </th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={`${packKey}-${idx}`}>
                <td>
                  <input
                    className="form-control form-control-sm"
                    value={row.quantityPack}
                    onChange={(e) => onChange(packKey, idx, 'quantityPack', e.target.value)}
                    readOnly={readOnly}
                    disabled={readOnly}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control form-control-sm"
                    value={row.length}
                    onChange={(e) => onChange(packKey, idx, 'length', e.target.value)}
                    readOnly={readOnly}
                    disabled={readOnly}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control form-control-sm"
                    value={row.breadth}
                    onChange={(e) => onChange(packKey, idx, 'breadth', e.target.value)}
                    readOnly={readOnly}
                    disabled={readOnly}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control form-control-sm"
                    value={row.height}
                    onChange={(e) => onChange(packKey, idx, 'height', e.target.value)}
                    readOnly={readOnly}
                    disabled={readOnly}
                  />
                </td>
                <td className="tear-sheet-pack-cbm-cell">
                  <span className="tear-sheet-pack-cbm" title="(L × B × H) ÷ 1 000 000">
                    {formatBoxCbmDisplay(row.length, row.breadth, row.height)}
                  </span>
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control form-control-sm"
                    value={row.grossWt}
                    onChange={(e) => onChange(packKey, idx, 'grossWt', e.target.value)}
                    readOnly={readOnly}
                    disabled={readOnly}
                  />
                </td>
                <td>
                  <select
                    className="form-select form-select-sm"
                    value={row.barcodeTypeId}
                    onChange={(e) => onChange(packKey, idx, 'barcodeTypeId', e.target.value)}
                    disabled={readOnly}
                  >
                    <option value="">—</option>
                    {barcodeTypes.map((b) => (
                      <option key={b.id} value={String(b.id)}>
                        {b.name}
                      </option>
                    ))}
                  </select>
                </td>
                {!readOnly && (
                  <td className="text-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => onRemove(idx)}
                      disabled={rows.length <= 1}
                      aria-label="Delete row"
                    >
                      <FaTrash size={12} />
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!readOnly && (
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={onAdd}>
          <FaPlus size={10} className="me-1" /> Add row
        </button>
      )}
    </section>
  );
}
